import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Vue3StarRating from "vue3-star-ratings";
import StarRatingIcon from "./StarRatingIcon.vue";
import { computed, ref, watch } from "vue";

/* NOTE:
  This component uses only for correct working `StarRounded` component as prop.
  Options-API in ImageUpload.vue cannot set component as prop into another component
*/


export default /*#__PURE__*/_defineComponent({
  __name: 'StarRating',
  props: {
    modelValue: { default: () => {
      return 0;
    } }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const rating = ref<number>(props.modelValue);
const hoverRating = ref<number | null>(null);
const displayRating = computed(() => {
  if (hoverRating.value !== null) return hoverRating.value;
  return rating.value;
});

function setRating(option: number) {
  const value = Math.ceil(option);
  emit("update:modelValue", value);

  rating.value = value;
}

function handleHover(event: MouseEvent) {
  const element = event.currentTarget as HTMLDivElement;
  if (!element) return;

  const rect = element.getBoundingClientRect();
  const relativeX = event.clientX - rect.left;
  const fraction = relativeX / rect.width;
  const rawValue = fraction * 5;
  const clamped = Math.max(1, Math.min(5, Math.ceil(rawValue)));
  hoverRating.value = clamped;
}

function resetHover() {
  hoverRating.value = null;
}

watch(
  () => props.modelValue,
  (value) => {
    rating.value = Math.ceil(value);
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "frisbuy-iu__stars-wrap",
    onMousemove: handleHover,
    onMouseleave: resetHover
  }, [
    _createVNode(_unref(Vue3StarRating), {
      modelValue: displayRating.value,
      class: "frisbuy-iu__stars",
      numberOfStars: 5,
      starSize: 42,
      starColor: '#23252a',
      inactiveColor: '#e6e7ea',
      disableClick: false,
      customSvg: StarRatingIcon,
      "onUpdate:modelValue": setRating
    }, null, 8, ["modelValue"])
  ], 32))
}
}

})